import { render } from "./AddAssignPage.vue?vue&type=template&id=15e9fa18&ts=true"
import script from "./AddAssignPage.vue?vue&type=script&lang=ts"
export * from "./AddAssignPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__